import { render, staticRenderFns } from "./TryOurApp.vue?vue&type=template&id=0f65bee0&scoped=true"
import script from "./TryOurApp.vue?vue&type=script&setup=true&lang=ts"
export * from "./TryOurApp.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TryOurApp.vue?vue&type=style&index=0&id=0f65bee0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f65bee0",
  null
  
)

export default component.exports